import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { ORDER_STATUSES } from '../../../../config/constants';
import { downloadOrderInvoice } from '../../../../api/orders/orders';
import { NOTIFICATION_ORDER_ACTIONS } from '../../../../config/notifications';
import { hideNotification } from '../../../../store/actions/notification';
import { store } from "../../../../store/store"

function DownloadOrder(props) {
  const { order } = props;
  const onClick = () => {

    downloadOrderInvoice({
      data: {
        order: order.id,
        date: order.created_at
      },
      notificationId: NOTIFICATION_ORDER_ACTIONS
    });
  };

  if (
    order.status !== ORDER_STATUSES.PAID &&
   ( order.status !== ORDER_STATUSES.REFUNDED_SUCCESS ||
    ! order.neo_invoice_series ||
    ! order.neo_invoice_number )
  ) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={`download-order-icon-` + props.order.id}
        onClick={() => {
          store.dispatch(hideNotification());
          onClick();
        }}
      >
        <FontAwesomeIcon size="lg" className="cursor-pointer" pointerEvents="none" icon={faDownload} />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`download-order-icon-${props.order.id}`}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: 'body'
          }
        }}
      >
        <FormattedMessage id="messages.download" />
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { DownloadOrder };
